module.exports = __webpack_public_path__ + "img/menu-b.0974d323.svg";